<template>
	<div class="cm-list-item-pricing">
		<div v-if="car.finance" class="item-finance">
			<template
				v-if="this.$store.state.price.filter === 'leasing' && car.leasing"
			>
				<div class="item-price text-end">
					<a
						class="dropdown-toggle dropdown-details d-inline-block price-top-label no-caret"
						href="#"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
						>Leasingrate<i
							class="show-icon mdi mdi-information-outline text-secondary ms-1"
						></i
						><i class="close-icon mdi mdi-close-thick text-secondary ms-1"></i>
					</a>
					<div
						style="min-width: 280px; max-width: 340px"
						class="dropdown-menu dropdown-menu-end dropdown-shadow p-0"
					>
						<dropdown-price-leasing :leasing="car.leasing" :car="car" />
					</div>
					<h5 class="price price-leasing">
						{{ getPrice(car.leasing.grossRate) }}<small>€</small>
					</h5>
				</div>
				<div class="item-price text-end">
					<span class="price-top-label"
						>Kaufpreis <sup>{{ hasVat }}</sup></span
					>
					<h5 class="price price-finance-vk">
						{{ getPrice(car.consumerPriceGross) }}<small>€</small>
					</h5>
				</div>
			</template>
			<template v-else>
				<div class="item-price text-end">
					<a
						class="dropdown-toggle dropdown-details d-inline-block price-top-label no-caret"
						href="#"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
						>Monatsrate<i
							class="show-icon mdi mdi-information-outline text-finance ms-1"
						></i
						><i class="close-icon mdi mdi-close-thick text-finance ms-1"></i>
					</a>
					<div
						style="min-width: 280px; max-width: 340px"
						class="dropdown-menu dropdown-menu-end dropdown-shadow p-0"
						aria-labelledby="dropdownMenuClickableInside"
					>
						<dropdown-price-financing :car="car" />
					</div>
					<h5 class="price price-finance">
						{{ getPrice(car.finance.monthlyInstallment) }}<small>€</small>
					</h5>
				</div>
				<div class="item-price text-end">
					<span class="price-top-label"
						>Kaufpreis <sup>{{ hasVat }}</sup></span
					>
					<h5 class="price price-finance-vk">
						{{ getPrice(car.consumerPriceGross) }}<small>€</small>
					</h5>
				</div>
			</template>
		</div>
		<template v-else>
			<div class="item-price text-end">
				<span class="price-top-label"
					>Kaufpreis <sup>{{ hasVat }}</sup></span
				>
				<h5 class="price price-vk">
					{{ getPrice(car.consumerPriceGross) }}<small>€</small>
				</h5>
			</div>

			<template v-if="car.dealerPriceGross > 0">
				<div class="item-price text-end pt-0">
					<h5 class="price price-upe">
						<s>{{ getPrice(car.dealerPriceGross) }}</s
						><small>€<sup>3</sup></small>
					</h5>
				</div>
			</template>
			<template v-if="car.dealerPriceGross > 0">
				<div class="item-price d-none text-end pt-0">
					<h5 class="price price-upe">
						<small>Preisvorteil</small>
						{{ getPrice(car.dealerPriceGross - consumerPrice) }}<small>€</small>
					</h5>
				</div>
			</template>
		</template>
	</div>
</template>

<script>
import DropdownPriceFinancing from '@/components/list/ListItemDropdownPriceFinancing'
import DropdownPriceLeasing from '@/components/list/ListItemDropdownPriceLeasing'

export default {
	name: 'ListItemPricing',
	components: {
		DropdownPriceFinancing,
		DropdownPriceLeasing,
	},
	props: ['car'],
	data() {
		return {
			leasingPopover: 'hidden',
			financePopover: 'hidden',
		}
	},
	computed: {
		hasVat() {
			if (this.car.ad.price.vatRate !== undefined) {
				return Number(this.car.ad.price.vatRate) > 0 ? 1 : 2
			} else {
				return 1
			}
		},
		consumerPrice() {
			return Number(this.car.ad.price.consumerPriceGross)
		},
	},
	mounted() {
		// eslint-disable-next-line no-undef
		//new bootstrap.Popover(exampleEl)
	},
}
</script>

<style lang="scss" scoped></style>
